import React, { useState, useRef } from 'react';
import { FormControl, Select, Checkbox, TableHead, Link, MenuItem, Paper, Popover, Table, TableBody, TableCell, TableContainer, TextField, TableRow } from '@mui/material'
import { useEffect } from 'react';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Container, Button, Stack, Typography, Card, CardContent, Tab, Box } from '@mui/material';
import { Grid } from '@mui/material';

export default function Reports() {
    const [tabValue, setTabValue] = React.useState('1');

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // useEffect(() => {
    //     // Function to disable right-click, F12 key, and combination for dev tools
    //     const disableDevTools = (event) => {
    //         // Prevent right-click menu
    //         if (event.button === 2) {
    //             event.preventDefault();
    //         }

    //         // Prevent F12 / Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C
    //         if (
    //             event.keyCode === 123 || // F12
    //             (event.ctrlKey && event.shiftKey && (event.keyCode === 73 || event.keyCode === 74 || event.keyCode === 67)) // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C
    //         ) {
    //             event.preventDefault();
    //         }
    //     };

    //     document.addEventListener('contextmenu', disableDevTools);
    //     document.addEventListener('keydown', disableDevTools);
    //     document.addEventListener('mousedown', disableDevTools);

    //     return () => {
    //         document.removeEventListener('contextmenu', disableDevTools);
    //         document.removeEventListener('keydown', disableDevTools);
    //         document.removeEventListener('mousedown', disableDevTools);
    //     };
    // }, []);

    return (
        <>
         <Container maxWidth="xxl">

<Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
    <Typography variant="h4" gutterBottom>
      Registration
    </Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
      <>
        <Stack direction="row" spacing={1}>
        <Button
        //   variant="outlined"
          variant="outlined"
          color="primary"
          href={process.env.REACT_APP_REG_REDIRECT}
          target="blank"
          rel="noopener noreferrer"
        
      >
          Click Here
      </Button>
        </Stack>
      </>
    </Stack>
  </Stack>

<Card>
<CardContent>

     <Grid container >
   
             <Grid item xs={12} lg={12}>
                 <TabContext value={tabValue}>
                     <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                         <TabList onChange={handleTabChange} aria-label="lab API tabs example" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                             {/* <Tab label="Registration Scrutinizer Report" value="1" /> */}
                             <Tab label="Registration Ageing" value="1" />
                             <Tab label="Scrutiny Ageing" value="2" />
                             <Tab label="Stakeholder Report" value="3" />
                             <Tab label="Grower Mapping Status" value="4" />
                             <Tab label="Lead Scrutinizer Details" value="5" />
                             <Tab label="SAP vendor ID" value="6" />
                             <Tab label="Application Status" value="7" />
                             <Tab label="Latitude Longitude Report" value="8" />
                         </TabList>
                         {/* <TabList onChange={handleTabChange} aria-label="lab API tabs example"> */}
                             
                             
                         {/* </TabList> */}
                     </Box>
                     {/* <TabPanel value="1">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Registration Scrutinizer Report" width="100%" height="540" src={process.env.REACT_APP_REG_SCRUITNIZER}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel> */}
                       <TabPanel value="1">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Registration Ageing" width="100%" height="540" src={process.env.REACT_APP_REG_AGEING}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                       <TabPanel value="2">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Scrutiny Ageing" width="100%" height="540" src={process.env.REACT_APP_SCRUTINITY_AGEING}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                       <TabPanel value="3">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Stakeholder Report" width="100%" height="540" src={process.env.REACT_APP_STAKEHOLDER_REPORT}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                       <TabPanel value="4">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Grower Mapping Status" width="100%" height="540" src={process.env.REACT_APP_GROWER_MAPPING_REPORT}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                       <TabPanel value="5">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Lead Scrutinizer Details" width="100%" height="540" src={process.env.REACT_APP_REG_SCRUITNIZER_DETAIL}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                      
                       <TabPanel value="6">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="SAP vendor ID" width="100%" height="540" src={process.env.REACT_APP_REG_STAKEHOLDER_2}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                       <TabPanel value="7">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Application Status" width="100%" height="540" src={process.env.REACT_APP_REG_STATUS_REPORT}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                       <TabPanel value="8">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Latitude Longitude Report" width="100%" height="540" src={process.env.REACT_APP_REG_LAT_LONG_REPORT}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                  </TabContext>
              </Grid>
          </Grid >

  {/* <Grid Container>
      <Typography gutterBottom variant='h5'>PIT Report</Typography>
      <Grid item xs={12} lg={12}>

          <iframe title="Stakeholder_report" width="100%" height="540" src="
https://app.powerbi.com/view?r=eyJrIjoiYmI4Y2YwZTktZTEwNC00OWQyLTliMDQtMWRjOGE0NzIxNzVkIiwidCI6ImIwMzliZjI1LTE2N2YtNDQzZC1iZDZlLTExZDA3ZDY2OTA3NyJ9"
              frameborder="0" allowFullScreen="true"></iframe>
      </Grid>
      <Grid item xs={12} lg={12}>
          <Button
          variant="outlined"
          color="primary"
          href="https://app.powerbi.com/Redirect?action=OpenApp&appId=86285238-d875-4a2f-87bc-2f73e9c2f989&ctid=b039bf25-167f-443d-bd6e-11d07d669077"
          style={{ padding: '10px 20px', fontSize: '1em' }}
      >
          Click Here
      </Button>

      </Grid>
  </Grid> */}
</CardContent>
</Card>
</Container>
        </>
    );
}